// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8f1501b4","295":"f5b4f99f","413":"3a208354","480":"c354b7e8","963":"6caffd78","988":"cd430cf8"}[chunkId] + ".chunk.js";
};